import { Component } from 'react';
import { IBaseComponentProps } from '../props/IBaseComponentProps';
import Styles from './NSFilterItem.module.css'
import { FilterItem } from 'namirasoft-core';

interface INSFilterItemProps extends IBaseComponentProps
{
	item: FilterItem
	removeSelected: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, item: FilterItem) => void
}

export class NSFilterItem extends Component<INSFilterItemProps>
{
	override render()
	{
		return (
			<div className={Styles.ns_filter_item}>
				<span>{this.props.item.toString()}</span>
				<button
					className={Styles.ns_filter_item_close}
					onClick={(e) => this.props.removeSelected(e, this.props.item)}
				>
					<img src="https://static.namirasoft.com/image/concept/close/blue.svg" alt="close" width={24} height={24} />
				</button>
			</div>
		);
	}
}